import React, { useState,useRef,useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { configData } from "../config";
import "./classes/PurchaseOrder.css";
import "./classes/Main.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCheck, faXmark, faPrint } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from 'react-helmet';
import { useReactToPrint } from "react-to-print";

const PurchaseOrder = () => {
  const products = [
    { id: 1, name: "Fanta 330", barcode: "52554654", stock: 82,unitCost: 25 },
    { id: 2, name: "Coke 500", barcode: "98765432", stock: 40 ,unitCost: 25},
    { id: 3, name: "mixed fruits" ,barcode: "10003", stock: 82,unitCost: 25 },
    { id: 4, name: "bath soap",barcode: "10004" , stock: 82 ,unitCost: 25},
    { id: 5, name: "toothpaste", barcode: "10005", stock: 82 ,unitCost: 25 },
    { id: 6, name: "shampoo", barcode: "10006", stock: 82 ,unitCost: 25 },
    { id: 7, name: "rice 1kg",  barcode: "10007" , stock: 82 ,unitCost: 25},
    { id: 8, name: "wheat flour 1kg",  barcode: "10008", stock: 82,unitCost: 25  },
    { id: 9, name: "sugar 1kg",barcode: "10009", stock: 82 ,unitCost: 25 },
    { id: 10, name: "salt packet",  barcode: "10010" , stock: 82 ,unitCost: 25},
    { id: 11, name: "cooking oil 1L",barcode: "10011" , stock: 82,unitCost: 25 },
    { id: 12, name: "milk 1L",  barcode: "10012" , stock: 82 ,unitCost: 25},
    { id: 13, name: "butter",  barcode: "10013", stock: 82 ,unitCost: 25 },
    { id: 14, name: "bread loaf",barcode: "10014", stock: 82,unitCost: 25  },
    { id: 15, name: "biscuits",  barcode: "10015", stock: 82 ,unitCost: 25 },
    { id: 16, name: "tea powder", barcode: "10016", stock: 82 ,unitCost: 25 },
    { id: 17, name: "coffee powder",  barcode: "10017", stock: 82,unitCost: 25  },
    { id: 18, name: "detergent powder", barcode: "10018", stock: 82,unitCost: 25  },
    { id: 19, name: "handwash", barcode: "10019" , stock: 82,unitCost: 25 },
    { id: 20, name: "face wash", barcode: "10020" , stock: 82 ,unitCost: 25}
  ];
  const app_url = configData.APP_URL;

  // Invoice number: persist in localStorage, auto-increment per order
  // const getNextInvoiceForDisplay = () => {
  //   const stored = localStorage.getItem("pos_invoice_number");
  //   const next = stored ? parseInt(stored, 10) + 1 : 1001;
  //   localStorage.setItem("pos_invoice_number", String(next));
  //   return next; // next invoice number for the next order
  // };
  //const [invoiceNumber, setInvoiceNumber] = useState(() => {
  //   const stored = localStorage.getItem("pos_invoice_number");
  //   return stored ? parseInt(stored, 10) + 1 : 1001; // next to use for this order
  //});
  const [invoiceNumber, setInvoiceNumber] = useState(null);
const fetchInvoiceNumber = async () => {
  try {
    const res = await fetch(app_url + "sales/get-invoice-number");
    const data = await res.json();

    if (data.success) {
      setInvoiceNumber(data.invoice_number);
      return data.invoice_number;
    }
  } catch (error) {
    console.error("Error fetching invoice number:", error);
  }
};
useEffect(() => {
  fetchInvoiceNumber();
}, []);
  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const [unitCost, setUnitCost] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lines, setLines] = useState([]);
  const [customerType, setCustomerType] = useState("retail");
  const [paymentType, setPaymentType] = useState("cash");
  const [cashReceived, setCashReceived] = useState("");
 // const inputRef = useRef(null);
  const inputSearchRef = useRef(null);
  useEffect(() => {
    inputSearchRef.current?.focus();
  }, []);
  // useEffect(() => {
  //   if (searchValue === "") {
  //     inputSearchRef.current?.focus();
  //   }
  // }, [searchValue]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
      contentRef: contentRef,
      documentTitle: "Receipt",
    });

  const onPrintClick = () => {
    if (lines.length === 0) return;
    if (paymentType === "cash") {
      const cash = parseFloat(cashReceived) || 0;
      if (cash < grandTotal) {
        // alert(`Cash received (₹${cash.toFixed(2)}) is less than total (₹${grandTotal.toFixed(2)}). Please enter the correct amount.`);
        return;
      }
    }
    handlePrint();
  };

  const canSaveOrPrint = () => {
    if (lines.length === 0) return false;
    if (paymentType === "cash") {
      const cash = parseFloat(cashReceived) || 0;
      return cash >= grandTotal;
    }
    return true;
  };

      // useEffect(() => {
      //     const handler = setTimeout(() => {
      //     if (searchValue.trim() === "") {
      //         setOptions([]);
      //         return;
      //     }
      //     setOptions(products.filter(p => p.name.includes(searchValue.toLowerCase())));
      //     }, 300);
  
      //     return () => clearTimeout(handler);
      // }, [searchValue]);
          useEffect(() => {
    const fetchData = async () => {
      if (searchValue.trim() === '') {
        setOptions([]); // Clear options if search is empty
        return;
      }
      try {
        const response = await fetch(app_url+'items/getproductlist?query='+searchValue+'&type='+customerType);
        const data = await response.json();
        setOptions(data); 
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const handler = setTimeout(() => {
      fetchData();
    }, 500); // Debounce for 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue,customerType]);
  const handleCustomerTypeChange = (e) => {
  setCustomerType(e.target.value);
  setOptions([]); // reset prices 
};
      
// const handleKeyDown = (e) => {
//   if (e.key !== "Enter") return;

//   e.preventDefault();
//   const input = searchValue.trim();
//   if (!input) return;

//   // Barcode scan
//   const barcodeMatch = products.find(p => p.barcode === input);
//   if (barcodeMatch) {
//     addLineFromProduct(barcodeMatch);
//     return;
//   }

//   //  Enter on selected product
//   if (selectedProduct) {
//     addLineFromProduct(selectedProduct);
//   }
// };
const handleKeyDown = async (e) => {
  if (e.key !== "Enter") return;

  e.preventDefault();
  if (!searchValue.trim()) return;

  try {
    const res = await fetch(app_url+'items/getproductlist?query='+searchValue);
    const data = await res.json();

    if (data?.length === 1) {
      addLineFromProduct(data[0]);
    }
  } catch (err) {
    console.error(err);
  }
};



  const addLineFromProduct = (product) => {
  setLines(prevLines => {
    const existingLine = prevLines.find(
      line => line.barcode === product.barcode
    );

 
    if (existingLine) {
      return prevLines.map(line =>
        line.barcode === product.barcode
          ? {
              ...line,
              qty: line.qty + qty,
              lineTotal: (line.qty + qty) * line.unitCost
            }
          : line
      );
    }


    return [
      ...prevLines,
      {
        id: product.id,
        product: product.name,
        barcode: product.barcode,
        qty: qty,
        unitCost: unitCost || product.unitCost,
        lineTotal: qty * (unitCost || product.unitCost)
      }
    ];
  });

  // reset inputs
  setSelectedProduct(null);
  setSearchValue("");
  setQty(1);
  setUnitCost(0);

  setTimeout(() => inputSearchRef.current?.focus(), 0);
 
};



  const updateLine = (id, field, value) => {
    setLines(prev =>
      prev.map(line =>
        line.id === id
          ? {
              ...line,
              [field]: Number(value),
              lineTotal:
                field === "qty"
                  ? Number(value) * line.unitCost
                  : field === "unitCost"
                  ? line.qty * Number(value)
                  : line.lineTotal
            }
          : line
      )
    );
  };

  const removeLine = (id) => {
    setLines(prev => prev.filter(line => line.id !== id));
  };

  const grandTotal = lines.reduce((sum, line) => sum + line.lineTotal, 0);

const handleSubmit = async () => {
  if (isSubmitting) return;
  if (lines.length === 0) {
    alert("Add at least one product");
    return;
  }
  if (paymentType === "cash") {
    const cash = parseFloat(cashReceived) || 0;
    if (cash < grandTotal) {
      alert(`Cash received (₹${cash.toFixed(2)}) is less than total (₹${grandTotal.toFixed(2)}). Please enter the correct amount.`);
      return;
    }
  }
  setIsSubmitting(true);
  const payload = {
    //order_date: new Date().toISOString(),
    total_amount: grandTotal,
    customer_type: customerType,
    payment_type: paymentType,
    cash_received: paymentType === "cash"
        ? parseFloat(cashReceived) || 0
        : 0,
    change_amount: paymentType === "cash"
        ? (parseFloat(cashReceived) - grandTotal)
        : 0,
    items: lines.map(line => ({
      item_id:line.id,
      item_name: line.product,
      barcode: line.barcode,
      quantity: String(line.qty),
      price: line.unitCost,
      total: line.lineTotal
    }))
  };
console.log(payload);
  try {
    const res = await fetch(
      app_url + "sales/sales-items",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      }
    );

    const data = await res.json();

    if (data.success) {
      alert("Order saved successfully");
      setLines([]);
      setCashReceived("");
       await fetchInvoiceNumber();
    } else {
      alert("Failed to save order");
    }
  } catch (err) {
    console.error(err);
  } finally{
    setIsSubmitting(false);
  }
};

  return (
    <div className="pos-main purchase-order-page">
         <Helmet>
            <title>Create Purchase Order</title>
         </Helmet>
    <div className="create-purchase-order-container">
    <div className="po-modal">
      <div className="po-header">
      </div>

      <div className="po-body">
        <div className="row po-summary-row">
        <div className="main-total">
          Total: ₹{grandTotal.toFixed(2)}
        </div>
        {/* <div className="invoice-number">
          Invoice #: {invoiceNumber}
        </div> */}
        </div>

        <div className="po-options-row">
          <div className="po-option">
            <label htmlFor="customer-type">Customer Type</label>
            <select id="customer-type" value={customerType} onChange={handleCustomerTypeChange}>
              <option value="retail">Retail</option>
              <option value="wholesale">Wholesale</option>
            </select>
          </div>
          <div className="po-option">
            <label htmlFor="payment-type">Payment Type</label>
            <select id="payment-type" value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
              <option value="cash">Cash</option>
              <option value="credit">Credit</option>
            </select>
          </div>
          {paymentType === "cash" && (
            <div className="po-option po-cash-input">
              <label htmlFor="cash-received">Cash Received (₹) *</label>
              <input
                id="cash-received"
                type="number"
                step="0.01"
                min="0"
                placeholder="Enter amount"
                value={cashReceived}
                onChange={(e) => setCashReceived(e.target.value)}
              />
              {parseFloat(cashReceived) >= grandTotal && grandTotal > 0 && (
                <span className="change-display">Change: ₹{(parseFloat(cashReceived) - grandTotal).toFixed(2)}</span>
              )}
            </div>
          )}
        </div>

        <div className="add-line">
          <div>
            <p>Product</p>
            <div className="pos-autocomplete-search">
           <Autocomplete 
              disablePortal   
              className="pos-autocomplete"          
              options={options}
              getOptionLabel={(option) => option.name}
              value={selectedProduct}
              inputValue={searchValue}
              onInputChange={(e, value) => setSearchValue(value)}
              onChange={(e, value) => {
                if (!value) return;
                setSelectedProduct(value);
                setUnitCost(value.unitCost);
              }}
              renderOption={(props, option) => (
                <li {...props}>
                  <strong>{option.name}</strong>&nbsp;&nbsp;-&nbsp;
                  <span style={{ marginLeft: "10px", color: "#666" }}>
                    ₹{option.unitCost}
                  </span>
                  <span style={{ marginLeft: "10px", color: "#666" }}>
                    (Stock: {option.quantity_stock})
                  </span>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputRef={inputSearchRef}
                  placeholder="Search or scan barcode"
                  onKeyDown={handleKeyDown}
                 InputProps={{
                ...params.InputProps,
                  endAdornment: (
                  <div className="pos-end-adornment">
                    {params.InputProps.endAdornment}
                  </div>
                ),
              }}
                />
              )}
            />
</div>
          </div>
          <div>
            <p>Qty</p>
            <input
              type="number"
              min="1"
              value={qty}
              onChange={e => setQty(e.target.value)}
            />
          </div>
          <div>
            <p>Unit Cost (₹)</p>
            <input
              type="number"
              step="0.01"
              value={unitCost}
              onChange={e => setUnitCost(e.target.value)}
            />
          </div>
    <button onClick={() => selectedProduct && addLineFromProduct(selectedProduct)} className="add-line-button" style={{cursor:"pointer"}}>
  <FontAwesomeIcon icon={faPlus} /> Add Line
</button>

        </div>
        
        <div className="purchase-table">
          <div className="purchase-table-desktop">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Unit Cost</th>
                  <th>Line Total</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {lines.length > 0 ? (<>
                {lines.map((line, index) => (
                  <tr key={line.id}>
                    <td>{index + 1}</td>
                    <td>{line.product}</td>
                    <td>
                      <input
                        type="number"
                        value={line.qty}
                        onChange={e => updateLine(line.id, "qty", e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={line.unitCost}
                        onChange={e =>
                          updateLine(line.id, "unitCost", e.target.value)
                        }
                      />
                    </td>
                    <td>₹{line.lineTotal.toFixed(2)}</td>
                    <td><FontAwesomeIcon style={{color:"red",cursor:"pointer"}} icon={faXmark} onClick={() => removeLine(line.id)}/>
                    </td>
                  </tr>
                ))}
                </>):(<tr><td colSpan={6}>No items yet</td></tr>)}
                <tr className="final-total-row">
                  <td colSpan={4} className="final-total-label">
                    Total
                  </td>
                  <td className="final-total-amount">
                    ₹{grandTotal.toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="purchase-cards-mobile">
            {lines.length > 0 ? (
              <>
                {lines.map((line, index) => (
                  <div key={line.id} className="po-line-card">
                    <div className="po-line-card-header">
                      <span className="po-line-card-product">{line.product}</span>
                      <button type="button" className="po-line-card-remove" onClick={() => removeLine(line.id)} aria-label="Remove">
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                    <div className="po-line-card-body">
                      <div className="po-line-card-field">
                        <label>Qty</label>
                        <input
                          type="number"
                          min="1"
                          value={line.qty}
                          onChange={e => updateLine(line.id, "qty", e.target.value)}
                        />
                      </div>
                      <div className="po-line-card-field">
                        <label>Unit Cost (₹)</label>
                        <input
                          type="number"
                          step="0.01"
                          value={line.unitCost}
                          onChange={e => updateLine(line.id, "unitCost", e.target.value)}
                        />
                      </div>
                      <div className="po-line-card-total">
                        ₹{line.lineTotal.toFixed(2)}
                      </div>
                    </div>
                  </div>
                ))}
                <div className="po-cards-total">
                  <span>Total</span>
                  <span>₹{grandTotal.toFixed(2)}</span>
                </div>
              </>
            ) : (
              <div className="po-cards-empty">No items yet</div>
            )}
          </div>
        </div>
        {/* <div className="total">
          <strong>Total: ₹{grandTotal.toFixed(2)}</strong>
        </div> */}

        <div className="billing-actions" style={{textAlign:"right"}}>
          <a className="cancel" href="/purchase-order" style={{cursor:"pointer"}}>Cancel</a>&nbsp;
          <button className="save" disabled={isSubmitting} style={{ cursor: "pointer" }} onClick={handleSubmit} >
            <FontAwesomeIcon icon={faCheck} />  {isSubmitting ? "Saving..." : "Save Order"}</button>&nbsp;
          <button
            className="save save-print"
            disabled={isSubmitting}
            style={{ cursor: "pointer", backgroundColor: "#E03F5B" }}
            onClick={() => {
              canSaveOrPrint();
              onPrintClick();
              handleSubmit();
            }}
          >
            <FontAwesomeIcon icon={faPrint} />  Save & Print
          </button>
        </div>
      </div>
    </div>
    </div>
<div ref={contentRef} className="printContent">
  <div className="receipt">

    <div className="center bold">INVOICE</div>

    <div className="center small">
      Invoice #: {invoiceNumber}
      <br />
      Date: {new Date().toLocaleString()}
      <br />
      Customer: {customerType === "wholesale" ? "Wholesale" : "Retail"}
      <br />
      Payment: {paymentType === "cash" ? "Cash" : "Credit"}
    </div>

    <div className="dash-line"></div>

    <div className="items-header">
      <span>Qty</span>
      <span>Item</span>
      <span className="right">Price</span>
    </div>

    <div className="dash-line"></div>

    {lines.map(line => (
      <div key={line.id} className="item-row">
        <span>{line.qty}</span>
        <span className="item-name">{line.product}</span>
        <span className="right">₹{line.lineTotal.toFixed(2)}</span>
      </div>
    ))}

    <div className="dash-line"></div>

    <div className="row total bold">
      <span>TOTAL:</span>
      <span>₹{grandTotal.toFixed(2)}</span>
    </div>

    {paymentType === "cash" && parseFloat(cashReceived) >= grandTotal && (
      <>
        <div className="row">
          <span>CASH:</span>
          <span>₹{parseFloat(cashReceived).toFixed(2)}</span>
        </div>
        <div className="row">
          <span>CHANGE:</span>
          <span>₹{(parseFloat(cashReceived) - grandTotal).toFixed(2)}</span>
        </div>
      </>
    )}

    <div className="center thanks">*** THANK YOU ***</div>

  </div>
</div>


    </div>
    
  );
};

export default PurchaseOrder;